import { styled } from 'styled-components';
import Button from './Button';

type StyledCTAButtonProps = {
  width?: string;
};

const StyledCTAButton = styled(Button)<StyledCTAButtonProps>`
  width: ${({ width }) => width || '100%'};

  @media (min-width: 426px) {
    width: ${({ width }) => width || '50%'};
  }
`;

export default StyledCTAButton;
